'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT = exports.DEFAULT = 'TQ_PLUS/DEFAULT';
var CONFIRM = exports.CONFIRM = 'TQ_PLUS/CONFIRM';
var LOGIN = exports.LOGIN = 'TQ_PLUS/LOGIN';
var RULES = exports.RULES = 'TQ_PLUS/RULES';


//////////////////
// WEBPACK FOOTER
// ./src/constants/modals.js
// module id = 78
// module chunks = 0